module.exports = __webpack_public_path__ + "img/cd.2083247f.svg";